import { render, staticRenderFns } from "./ByChoice.vue?vue&type=template&id=5876240c&scoped=true"
import script from "./ByChoice.vue?vue&type=script&lang=js"
export * from "./ByChoice.vue?vue&type=script&lang=js"
import style0 from "./ByChoice.vue?vue&type=style&index=0&id=5876240c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5876240c",
  null
  
)

export default component.exports